/**
 * @file gtmを扱うためのUtility関数群
 */
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

// 画面遷移するたびにロードイベントをプッシュする
const useGtmLoadTracking = () => {
  const { listen } = useHistory()

  useEffect(() => {
    const unlisten = listen((location) => {
      if (!window.dataLayer) return
      window.dataLayer.push({ event: 'gtm.load' })
    })

    return unlisten
  }, [listen])
}

export { useGtmLoadTracking }
